import { Flex, Text, TextContainer } from "@wayflyer/flyui";
import type { ReactNode } from "react";
import { useIntl } from "react-intl";

import { MESSAGES } from "../message-definitions";

export const BusinessModelGeoLetDown = ({
  eligibilityLink,
  isMultiSelectBusinessModelFlow,
}: {
  eligibilityLink: ReactNode;
  isMultiSelectBusinessModelFlow: boolean;
}) => {
  const intl = useIntl();

  return (
    <Flex direction="column" gap="4">
      {isMultiSelectBusinessModelFlow ? (
        <TextContainer>{intl.formatMessage(MESSAGES.letDownReasonBusinessModelGeoMultiSelect)}</TextContainer>
      ) : (
        <TextContainer>{intl.formatMessage(MESSAGES.letDownReasonBusinessModelGeo)}</TextContainer>
      )}
      <Text>{eligibilityLink}</Text>
    </Flex>
  );
};
